import { Helmet } from 'react-helmet-async';

/**
 * Título, meta descripción, canonical y JSON-LD propios de una ruta. Montado dentro de
 * una página, react-helmet-async sobreescribe el <Helmet> por defecto de App.js mientras
 * esa página esté activa, y lo restaura solo al desmontarse — así cada ruta tiene su
 * propio <title>/meta sin que una herramienta se quede pegada en otra al navegar dentro
 * de la SPA (bug real: /severance y /net-salary servían el title/description del home).
 */
export function PageSEO({ title, description, canonical, jsonLd }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
